// Self-hosted Montserrat (one variable woff2 covering 100–900). Imported before
// index.css so the @font-face rules are registered first.
import '@fontsource-variable/montserrat';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { router } from '@/routes/router';

import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
